import { IdTitleMnemonicModel } from './../models/id-title-mnemonic.model';
import { UserModel } from './../models/user.model';
import { CompanyinfoApiModel } from './../models/companyinfo-api.model';
import { DeliveryTypeApiModel } from './../modules/cart/models/delivery-type-api.model';
import { EventEmitter, Injectable } from '@angular/core';

import { CategoryLookupModel } from '../models/category-lookup.model';
import { IdNameMnemonicModel } from '../models/id-name-mnemonic.model';
import { PaginatorModel } from '../models/paginator.model';
import { QueryApiModel } from '../modules/cart/models/query-api.model';
import { WarehouseApiModel } from '../modules/cart/models/warehouse-api.model';
import { CartEditApiModel } from '../models/cart-edit-api.model';
import { ProductApiModel } from '../modules/cart/models/product-api.model';

@Injectable()
export class ValStorageService {
    // Constants
    public readonly veleprodajaPosMnemonic = 'VELEPRODAJA';
    public readonly deliveryToHouseMnemonic = 'DELIVERY_TO_HOUSE';
    public readonly labelMnemonic = 'PRODUCT_LABEL';
    public readonly currencyCode = 'EUR';
    public readonly paymentType = 'PART';
    public readonly deliveryAddressType = 'A';
    public readonly leadTravellerCartAddressTypeMnemonic = 'LT';
    public readonly paymentStatus = 'OK';
    public readonly saving = $localize`Saving`;
    public readonly success = $localize`Success`;
    public readonly error = $localize`Error`;
    public readonly quoteInvoiceTypeId = 3; // skupna narudžba
    public readonly deliveryNoteInvoiceTypeId = 4; // otpremnica
    public readonly commonInvoiceTypeId = 1; // faktura

    // Variables
    public user: UserModel;
    public cart: Array<QueryApiModel> = [];
    public editedOrder: CartEditApiModel;
    public selectedMainCategoryId: string;
    public selectedChildCategoryId: string;
    public search: string;
    public sort: string;
    public sortDir: number;
    public currentPage: PaginatorModel;
    public company: CompanyinfoApiModel;
    public savedCartId: string;
    public itemDetails: ProductApiModel;
    public refreshPrice = new EventEmitter<number>();
    public currentHistoryEvent = new EventEmitter<string>();
    public showSearchEvent = new EventEmitter<boolean>();
    public searchEvent = new EventEmitter<string>();

    // Lookups
    public categories: Array<CategoryLookupModel>;
    public pointOfSales: Array<IdNameMnemonicModel>;
    public deliveryTypes: Array<DeliveryTypeApiModel>;
    public regions: Array<IdNameMnemonicModel>;
    public warehouses: Array<WarehouseApiModel>;

    constructor() { }
}
